import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import dynamic from 'next/dynamic';

const ArticleTeaserCard = dynamic(() =>
  import('@components/organisms/ArticleTeaserCard/ArticleTeaserCard').then((module) => module.ArticleTeaserCard),
);
const Carousel = dynamic(() => import('@components/molecules/Carousel/Carousel').then((module) => module.Carousel));

export default function PageContentElementArticles(element, showInitially) {
  const { articles } = element;

  return (
    <div className="pl-4 sm:pl-8 lg:pl-16">
      <ShowAllTitle title={element.title} link={element.title_link} />
      {articles && (
        <Carousel classProps={{ slide: '!h-auto' }}>
          {articles.map((article, index) => (
            <ArticleTeaserCard
              key={index}
              article={article}
              hideCategory
              classProps={{
                root: 'w-80',
                ImageContainer: 'w-full h-full px-6 pt-6',
                Image: 'relative w-full h-full rounded-lg overflow-hidden aspect-teaser lg:aspect-video',
              }}
              showInitially={showInitially && index < 2}
            />
          ))}
        </Carousel>
      )}
    </div>
  );
}
